import { api } from "./apiConfig";

export const getServices = async () => {
  const { data } = await api.get("/service");
  return data;
};

export const saveService = async (data) => {
  await api.post("/service", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const patchService = async ({ id, formData }) => {
  await api.patch(`/service/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const deleteService = async (id) => {
  await api.delete(`/service/${id}`);
};
